import {ColumnDef, ColumnHelper, createColumnHelper} from "@tanstack/react-table";
import moment from "moment";
import { QuickPayRequestMap } from "../../utils/helpers/mappers";
import { formatAmountToString } from "../../utils/helpers/logicHelper";


const column: ColumnHelper<IQuickPaymentRequest> = createColumnHelper<IQuickPaymentRequest>()

export const QuickPaymentRequestsColumn = [
  column.accessor('created_at', {
    header: () => <span>Date</span>,
    cell: info => <span
      className="text-truncate">{moment(info.getValue()).format('LL')}</span>,
    footer: info => info.column.id,
  }),
  column.accessor('amount', {
      header: () => <span>Amount</span>,
      cell: info => <span>{info.row.original.amount ? formatAmountToString(info.row.original.amount) : '-'}</span>,
      footer: info => info.column.id,
    }),
    column.accessor('reason', {
      header: () => <span>Reason</span>,
      cell: info => <span>{info.row.original.reason ? info.row.original.reason : '-'}</span>,
      footer: info => info.column.id,
    }),
  // column.accessor('requested_amount', {
  //   header: () => <span>Requested Amount</span>,
  //   cell: info => <span className="text-truncate">{info.row.original.requested_amount ? formatAmountToString(info.row.original.requested_amount) : '-'}</span>,
  //   footer: info => info.column.id,
  // }),
  column.accessor('status', {
    header: () => <span>Status</span>,
    cell: info => <span className={`badge rounded-pill ${QuickPayRequestMap[info.getValue()].fill}`}>{QuickPayRequestMap[info.getValue()].label}</span>,
    footer: info => info.column.id,
  }),
] satisfies ColumnDef<IQuickPaymentRequest, any>[];
